import { FC, useMemo } from 'react'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { feedSelectedGroupSelector } from 'selectors/feedSelectors'
import ModuleHeader from 'components/features/pfm/ModuleWrapper/ModuleHeader'

type PostListModuleHeaderProps = {

}

export const PostListModuleHeader: FC<PostListModuleHeaderProps> = (props) => {
  const { } = props

  const selectedFilterGroup = useStoreSelector(feedSelectedGroupSelector)

  const postListTitleText = useMemo(() => {
    if (!selectedFilterGroup) {
      return 'Posts'
    }
    if (selectedFilterGroup.type === 'your-posts') {
      return 'Your Posts'
    }

    if (selectedFilterGroup.type === 'feedgroup') {
      switch (selectedFilterGroup.slug) {
        case 'everyone':
          return 'Posts for Everyone'
        case 'followed_people':
          return 'Posts from People You Follow'
        case 'followed_tags':
          return 'Posts from Tags You Follow'
        case 'followed_posts':
          return 'Posts You Follow'
        default:
          return 'Posts'
      }
    }

    if (!selectedFilterGroup.relation) {
      return 'Posts'
    }

    switch (selectedFilterGroup.relation.slug) {
      case 'peers':
        return 'Posts for You and Your Peers'
      case 'random':
        return 'Posts for a Random Group'
      default:
        return `Posts for ${ selectedFilterGroup.relation.name }`
    }
  }, [selectedFilterGroup])

  if (!selectedFilterGroup) {
    return null
  }

  return (
    <ModuleHeader title={ postListTitleText } />
  )
}
